import { createActionFactory } from '../../common/redux';

const { createAction, createApiFailureAction } = createActionFactory('Domain => ');

const fetchDomains = createAction('fetch domain list', fetchParams => ({ fetchParams }));
const fetchDomainsSuccess = createAction('fetch domain list success', domains => ({ domains }));
const fetchDomainsFailure = createApiFailureAction('fetch domain list failure', error => ({ error }));

const removeDomain = createAction('remove domain from list', domainId => ({ domainId }));
const resetDomainList = createAction('reset domain list');

const fetchAvailableDomains = createAction('fetch available domain list', channelTypeRef => ({ channelTypeRef }));
const fetchAvailableDomainsSuccess = createAction('fetch available domain list success', domains => ({ domains }));
const fetchAvailableDomainsFailure = createApiFailureAction('fetch available domain list failure', error => ({
  error,
}));

export default {
  fetchDomains,
  fetchDomainsSuccess,
  fetchDomainsFailure,
  fetchAvailableDomains,
  fetchAvailableDomainsSuccess,
  fetchAvailableDomainsFailure,
  removeDomain,
  resetDomainList,
};
